module.exports = __webpack_public_path__ + "static/spacewalk-8226fd5de8b70745a3742679a6ed8aed.jpg";